import SockJS from "sockjs-client";
import Stomp, {Client} from "webstomp-client";
import {IStompSubscription} from "@/model/IStompSubscription";
import {IAuthData} from "@/model/IAuthData";
import {Fetch} from "water-rest/src/fetch/Fetch";

let socket: WebSocket;
let stompClient: Client;
let connected = false;
let subscriptions = Array<IStompSubscription>();

export const connect = (authData: IAuthData) => {
    socket = new SockJS(`${Fetch.buildWsUrl()}?X-Auth=${authData.jwt}`);
    stompClient = Stomp.over(socket);
    stompClient.connect(
        {},
        frame => {
            connected = true;
            if ( subscriptions.length ) {
                subscriptions.forEach( (eachSubscription) => {
                    if ( eachSubscription.subscription )
                        eachSubscription.subscription.unsubscribe();

                    eachSubscription.subscription = stompClient.subscribe( eachSubscription.topicName, (message) => {
                        const body = JSON.parse(message.body);
                        if ( eachSubscription.callback && typeof eachSubscription.callback === 'function' )
                            eachSubscription.callback(body);
                    } );
                } );
            }
        },
        (error) => {
            console.error(error);
            connected = false;

            console.warn('Reconnecting to stomp...');
            setTimeout( () => {
                connect(authData)
            }, 10000 );
        }
    );
}

export const reconnect = (authData: IAuthData) => {
    stompClient.disconnect();
    connected = false;
    connect(authData);
}

export const unsubscribe = (subscriptionName: string) => {
    subscriptions = subscriptions.filter( (eachSubscription) => {
        if ( eachSubscription.subscriptionName === subscriptionName ) {
            eachSubscription.subscription?.unsubscribe();
        }

        return eachSubscription.subscriptionName !== subscriptionName;
    } )
}

export const unsubscribeAll = () => {
    subscriptions.forEach( (eachSubscription) => {
        eachSubscription.subscription?.unsubscribe();
    } );

    subscriptions = Array<IStompSubscription>();
    if ( stompClient && stompClient.connected )
        stompClient.disconnect();
    connected = false;
}

export const subscribeToStomp = (subscription: IStompSubscription) => {
    const existingSubscription = subscriptions.find( (eachSubscription) => {
        return eachSubscription.subscriptionName === subscription.subscriptionName
    } );
    if ( existingSubscription ) {
        console.warn(`Subscription with name ${subscription.subscriptionName} already exists!`);
        unsubscribe(subscription.subscriptionName);
    }

    if ( stompClient && stompClient.connected )
        subscription.subscription = stompClient.subscribe( subscription.topicName, (message) => {
            const body = JSON.parse(message.body);
            if ( subscription.callback && typeof subscription.callback === 'function' )
                subscription.callback(body);
        } );

    subscriptions.push(subscription);
}
